<div class="toast-item">
  <div class="icon-container">
    <ion-icon *ngIf="toastType === 'toast-success'" name="checkmark-circle-sharp"></ion-icon>
    <ion-icon *ngIf="toastType === 'toast-info'" name="alert-circle"></ion-icon>
    <ion-icon *ngIf="toastType === 'toast-warning'" name="warning"></ion-icon>
    <ion-icon *ngIf="toastType === 'toast-error'" name="close-circle"></ion-icon>
  </div>
  <div class="content">
    <div class="title">{{ title }}</div>
    <div class="message">
      {{ message }}
    </div>
    <div class="actions">
      <button *ngIf="toastType === 'toast-error'" (click)="copyError()">
        <div class="icon">
          <ion-icon [ngClass]="{ show: !errorCopied, hide: errorCopied }" name="copy-outline"></ion-icon>
          <ion-icon [ngClass]="{ show: errorCopied, hide: !errorCopied }" name="checkmark-outline"></ion-icon>
        </div>
        <span>Copy Error</span>
      </button>
    </div>
  </div>
  <button class="close-btn" (click)="dismiss()"><ion-icon name="close"></ion-icon></button>
</div>
